import { palette } from '@/theme/constants';

export const styles = {
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  divider: {
    border: `0.063rem solid ${palette.gray}`,
    marginBottom: '0.5rem',
    width: '100%',
  },
};
